var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { constants } from '../settingConstants';
import { useTypeSelector } from '../../../../hooks/useTypeHooks';
import { selectPreferences } from '../../../../Redux/selectors/selectors';
import styles from '../SettingsModalContent.module.scss';
import Hotkeys from './HotKeys/HotKeys';
import ChangeSettingsSection from './ChangeSettingsSection';
import { previewSections } from './utils';
var TabsContent = function () {
    var _a;
    var modalSettings = useTypeSelector(selectPreferences).modalSettings;
    var tabsContent = (_a = {},
        _a["".concat(constants.PRESETS)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'actions', title: 'presets', sections: previewSections[constants.PRESETS] }, 'presets')),
        _a["".concat(constants.STRATEGY)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'actions', title: 'actions', sections: previewSections[constants.STRATEGY] }, 'actions')),
        _a["".concat(constants.RANGE)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'range', title: 'range', type: 'matrix', sections: previewSections[constants.RANGE] }, 'range')),
        _a["".concat(constants.EV)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'ev', title: 'ev', type: 'matrix', sections: previewSections[constants.EV] }, 'ev')),
        _a["".concat(constants.EQUITY)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'equity', title: 'equity', type: 'matrix', sections: previewSections[constants.EQUITY] }, 'equity')),
        _a["".concat(constants.EQR)] = (_jsx(ChangeSettingsSection, { detailMatrixTitle: 'eqr', title: 'eqr', type: 'matrix', sections: previewSections[constants.EQR] }, 'eqr')),
        _a["".concat(constants.POSITIONS)] = (_jsx(ChangeSettingsSection, { title: 'positions', sections: previewSections[constants.POSITIONS] }, 'positions')),
        _a["".concat(constants.TEXT)] = _jsx(ChangeSettingsSection, { title: 'text', sections: previewSections[constants.TEXT] }, 'text'),
        _a["".concat(constants.CARDS)] = (_jsx(ChangeSettingsSection, { title: 'suits', sections: previewSections[constants.CARDS] }, 'suits')),
        _a["".concat(constants.TRAINER)] = _jsx(Hotkeys, {}),
        _a);
    return _jsx("section", __assign({ className: styles.tabsContentWrapper }, { children: tabsContent[modalSettings.localTabs] }));
};
export default TabsContent;
